<script>
import { ref, toRefs, watch } from "vue";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
export default {
	props: ["windowWidth", "windowHeight", "scrollTop"],
	emits: ["changeIsShow"],
	setup(props, { emit }) {
		const { windowWidth, windowHeight, scrollTop } = toRefs(props);
		const isShow = ref(false);
		const navsBox = ref(null);

		const showMenu = () => {
			emit("changeIsShow", !isShow.value);
			isShow.value = !isShow.value;
		};

		gsap.registerPlugin(ScrollToPlugin);
		const goAnchor = (id, e) => {
			isShow.value = false;
			e.preventDefault();
			gsap.to(document.body, {
				scrollTo: {
					y: id,
					offsetY:
						id === "#performance" ? -windowHeight.value - 75 : 0,
					autoKill: true,
				},
				ease: "power2.inOut",
				duration: 1.5,
			});
		};

		watch(scrollTop, (nv, ov) => {
			if (nv > 21.5 * windowHeight.value) {
				navsBox.value.style.display = "none";
			} else {
				navsBox.value.style.display = "block";
			}
		});

		return {
			windowWidth,
			isShow,
			showMenu,
			goAnchor,
			navsBox,
		};
	},
};
</script>

<template>
	<div
		class="navs-box"
		ref="navsBox"
		:style="{ height: isShow ? '100%' : '50px' }"
	>
		<!-- <transition name="fade">
			<a
				class="goto gotoForm"
				href="#form"
				@click="goAnchor('#form', $event)"
				v-sendGAsignal="{
					event_type: 'click',
					event_category: 'sidenavi',
					event_label: 'testdrive',
				}"
				v-show="windowWidth <= 992 && !isShow"
			>
				預約賞車
			</a>
		</transition>
		<transition name="fade">
			<a
				class="goto gotoEquipment"
				href="equipment/THE-4-gran-coupe-technical-data.pdf"
				target="_blank"
				v-sendGAsignal="{
					event_type: 'click',
					event_category: 'sidenavi',
					event_label: 'technical_data',
				}"
				v-show="windowWidth <= 992 && !isShow"
			>
				規格配備
			</a>
		</transition> -->
		<div class="menu-btn" @click="showMenu">
			<div :class="['longbar', { isShow }]"></div>
			<div :class="['shortbar', { isShow }]"></div>
		</div>
		<div :class="['menu-body', { isShow }]">
			<div class="menu-text" v-show="isShow">
				<a
					href="https://event.bmw.com.tw/campaign/2020/4-series-gran-coupe/onlineexhibition?utm_source=4gceventsite&utm_medium=4gceventsite&utm_campaign=4gceventsite"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'menu',
						event_label: 'onlineexhibition',
					}"
				>
					<span class="menu-text_inner">
						<span class="BMW-words">THE 4 </span>
						線上攝影展
					</span>
					<span class="number">01</span>
				</a>
				<a
					href="#exterior-text"
					@click="goAnchor('#exterior-text', $event)"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'menu',
						event_label: 'exterior',
					}"
				>
					<span class="menu-text_inner">鋒芒美型</span>
					<span class="number">02</span>
				</a>
				<a
					href="#technology-text"
					@click="goAnchor('#technology-text', $event)"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'menu',
						event_label: 'technology',
					}"
				>
					<span class="menu-text_inner">鋒格科技</span>
					<span class="number">03</span>
				</a>
				<a
					href="#performance"
					@click="goAnchor('#performance', $event)"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'menu',
						event_label: 'performance',
					}"
				>
					<span class="menu-text_inner">駕馭鋒采 </span>
					<span class="number">04</span>
				</a>
				<a
					href="#conception-text"
					@click="goAnchor('#conception-text', $event)"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'menu',
						event_label: 'THE4',
					}"
				>
					<span class="menu-text_inner">
						<span class="BMW-words">THE 4 </span>
						前衛美學
					</span>
					<span class="number">05</span>
				</a>
				<a
					href="#form"
					@click="goAnchor('#form', $event)"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'menu',
						event_label: 'testdrive',
					}"
				>
					<span class="menu-text_inner">預約賞車</span>
					<span class="number">06</span>
				</a>
			</div>
			<div class="footer-wrapper" v-show="isShow">
				<a
					class="site"
					href="https://www.bmw.com.tw/zh/index.html"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'menu',
						event_label: 'official_website',
					}"
				>
					<span class="BMW-words text_en_light">BMW TAIWAN </span>
					<span class="text_ch_medium">官網</span>
				</a>
				<a
					class="branch"
					href="https://www.bmw.com.tw/zh/owner/overview.html"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'menu',
						event_label: 'dealer',
					}"
				>
					<span class="BMW-words text_en_light">BMW </span>
					<span class="text_ch_medium">全台展示中心</span>
				</a>
				<a
					class="claim"
					href="https://www.bmw.com.tw/zh/footer/metanavigation/legal-disclaimer-pool/legal-disclaimer.html"
					target="_blank"
					v-sendGAsignal="{
						event_type: 'click',
						event_category: 'menu',
						event_label: 'legal_disclaimer',
					}"
				>
					<span class="text_ch_medium">網站聲明</span>
				</a>
				<div class="sns">
					<a
						class="facebook icon"
						href="https://www.facebook.com/BMWTaiwanOfficial/"
						target="_blank"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'menu',
							event_label: 'FB',
						}"
					>
					</a>
					<a
						class="instagram icon"
						href="https://www.instagram.com/bmwtaiwan/"
						target="_blank"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'menu',
							event_label: 'IG',
						}"
					>
					</a>
					<a
						class="line icon"
						href="https://page.line.me/bmwtaiwan"
						target="_blank"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'menu',
							event_label: 'LINE',
						}"
					>
					</a>
					<a
						class="youtube icon"
						href="https://www.youtube.com/user/BMWTWOFFCIAL"
						target="_blank"
						v-sendGAsignal="{
							event_type: 'click',
							event_category: 'menu',
							event_label: 'YouTube',
						}"
					>
					</a>
				</div>
				<div class="sep-line"></div>
				<div class="brand-text">
					<span class="text_ch_medium">© </span>
					<span class="BMW-words text_en_light">BMW </span>
					<span class="text_ch_medium">總代理 汎德股份有限公司</span>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="sass" scoped>
.navs-box
    position: fixed
    top: calc(2.6vw + 9.8px)
    right: calc(3.8vw + 17.4px)
    z-index: 550
    user-select: none
    cursor: pointer
    transition: height 0.8s
    .goto
        position: relative
        display: inline-block
        padding: 0px 34px
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2)
        font-family: arudjingxiheipe1xg30_md
        letter-spacing: 0.55px
        font-size: 1.1rem
        text-decoration: none
        vertical-align: middle
        z-index: 552
        &.gotoForm
            padding-right: 0
        &.gotoEquipment
            padding-left: 15px
    .menu-btn
        position: relative
        display: inline-block
        width: 24px
        height: 40px
        vertical-align: middle
        z-index: 2
        .longbar
            position: absolute
            width: 24px
            height: 1.2px
            top: 50%
            transform: translateY(-3px)
            background-color: #fff
            transition: 0.5s
            &.isShow
                transform: translateY(50%) rotate(20deg)
        .shortbar
            position: absolute
            width: 16px
            height: 1.2px
            top: 50%
            transform: translateY(3px)
            background-color: #fff
            margin-left: 8px
            transition: 0.5s
            &.isShow
                width: 24px
                margin: 0
                transform: translateY(50%) rotate(-20deg)

.menu-body
    position: absolute
    width: 0.01vw
    height: 100%
    top: calc(-2.6vw - 9.8px)
    right: calc(-3.8vw - 17.4px)
    background-color: rgba(#111, 0.8)
    backdrop-filter: blur(20.5px)
    -webkit-backdrop-filter: blur(20.5px)
    z-index: 1
    transition: width 0.5s
    transition-delay: 0.2s
    &.isShow
        width: 33vw
    .menu-text
        position: relative
        // padding-top: calc(2.6vw + 9.8px + 11.1% + 3px)
        top: calc(34.6% - 155.5px)
        padding-right: calc(3.8vw + 17.4px)
        a
            display: block
            user-select: none
            cursor: pointer
            text-decoration: none
            width: 100%
            height: 70px
            line-height: 70px
            text-align: right
            span
                display: inline-block
                height: 100%
                font-family: "BMWTypeNextLatinTT-Thin", serif
                font-size: 1.5rem
                letter-spacing: 1.3px
                color: rgba(#fff, 0.4)
                vertical-align: middle
                &.number
                    width: 21px
                    text-align: center
                &.menu-text_inner
                    font-family: arudjingxiheipe1xg30_md
                    font-size: 2.1rem
                    letter-spacing: 2.1px
                    padding-right: 2.6vw
                    color: #fff
                &.BMW-words
                    font-size: 2.1rem
                    letter-spacing: 1.26px
                    font-family: "BMWTypeNextLatinTT-Bold", serif
                    color: #fff
                    line-height: 68px
                    vertical-align: middle

    .footer-wrapper
        position: absolute
        width: calc(100% - 3.8vw - 17.4px)
        bottom: 0
        padding-right: calc(3.8vw + 17.4px)
        padding-bottom: calc(2vw + 22.4px)
        a
            display: block
            width: 100%
            height: 30px
            line-height: 30px
            user-select: none
            cursor: pointer
            text-decoration: none
            text-align: right
            span
                font-size: 1.3rem
                letter-spacing: 0.33px
                color: #ddd
                text-align: right
            .BMW-words
                font-size: 1.3rem
                letter-spacing: 1.17px
        .sns
            margin-top: 15px
            width: 100%
            text-align: right
            .icon
                display: inline-block
                background-size: cover
                background-position: center
                background-repeat: no-repeat
                margin-left: 21px
            .facebook
                width: 16px
                height: 30px
                background-image: url("~@/assets/FB.png")
            .instagram
                background-image: url("~@/assets/instagram.png")
            .line
                background-image: url("~@/assets/line.png")
            .youtube
                background-image: url("~@/assets/youtube.png")
            .instagram, .line, .youtube
                width: 30px
                height: 30px
        .sep-line
            position: relative
            display: inline-block
            width: 85%
            height: 1px
            right: 0
            margin-top: 30px
            margin-left: 15%
            background-color: rgba(#fff, 0.3)
        .brand-text
            display: block
            width: 100%
            height: 30px
            line-height: 30px
            user-select: none
            text-decoration: none
            text-align: right
            margin-top: 20px
            span
                font-size: 1.3rem
                letter-spacing: 0.33px
                color: #ddd
                text-align: right
            .BMW-words
                font-size: 1.3rem
                letter-spacing: 1.17px

.fade-enter-active, .fade-leave-active
    transition: opacity 0.3s ease
.fade-enter-from, .fade-leave-to
    opacity: 0
.fade-enter-to, .fade-leave-from
    opacity: 1

@media screen and (max-width: 1800px)
    .navs-box
        .menu-body
            .menu-text
                transform: scale(0.85)
                transform-origin: right top
@media screen and (max-width: 992px)
    .gotoForm-button
        right: 0px
    .navs-box
        .menu-body
            &.isShow
                width: 50vw
@media screen and (max-width: 768px)
    .navs-box
        .menu-body
            &.isShow
                width: 100vw
            .menu-text
                transform: scale(1)
                a
                    height: 50px
                    line-height: 50px
                    span
                        font-size: 1.3rem
                        letter-spacing: 0.68px
                        &.menu-text_inner
                            font-size: 1.4rem
                            letter-spacing: 1.4px
                        &.BMW-words
                            letter-spacing: 0.84px
                            line-height: 48px
            .footer-wrapper
                a
                    height: 40px
                    line-height: 40px
                    span
                        font-size: 1.1rem
                        letter-spacing: 0.99px
                        color: #999
                    .BMW-words
                        font-size: 1.1rem
                        letter-spacing: 0.28px
                .sns
                    .facebook
                        width: 9.8px
                        height: 18.5px
                    .instagram, .line, .youtube
                        width: 18.5px
                        height: 18.5px
                .sep-line
                    margin-top: 40px
                    width: 55%
                    margin-left: 45%
                .brand-text
                    height: 40px
                    line-height: 40px
                    margin-top: 20px
                    span
                        font-size: 1rem
                        letter-spacing: 0.23px
                        color: #999
                        transform: scale(0.9)
                    .BMW-words
                        font-size: 1rem
                        letter-spacing: 0.81px
</style>
